import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
import { LoginComponent } from './login/login.component';
import { NotAdminComponent } from './not-admin/not-admin.component';
import { TemplatesComponent } from './templates/templates.component';
import { MessagesComponent } from './messages/messages.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatGridListModule } from '@angular/material/grid-list';
import { Configuration, TokenResponse, ConfigurationParameters, ApiModule } from 'generated-sources/openapi';
import { environment } from 'src/environments/environment';
import { AdminGuard, AuthGuard } from './auth.guard';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MessageTableComponent } from './message-table/message-table.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { LayoutModule } from '@angular/cdk/layout';
import { TemplateFormComponent } from './template-form/template-form.component';
import { MatRadioModule } from '@angular/material/radio';

export function apiConfigFactory(): Configuration {
  console.log('building config');
  let tokens: TokenResponse = null;
  try {
    const s = window.localStorage.getItem('login');
    if (s) {
      tokens = JSON.parse(s);
    }
  } catch (err) {

  }
  const params: ConfigurationParameters = {
    // set configuration parameters here.
    basePath: environment.API_BASE_PATH,
    accessToken: tokens ? tokens.access_token : null
  };
  return new Configuration(params);
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    NotAdminComponent,
    TemplatesComponent,
    MessagesComponent,
    MessageTableComponent,
    TemplateFormComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    FormsModule,
    MatToolbarModule,
    MatSelectModule,
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    MatButtonToggleModule,
    MatListModule,
    MatSlideToggleModule,
    MatGridListModule,
    ApiModule.forRoot(apiConfigFactory),
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatMenuModule,
    MatIconModule,
    LayoutModule,
    MatRadioModule,
    ReactiveFormsModule
  ],
  providers: [AuthGuard, AdminGuard, { provide: HTTP_INTERCEPTORS, useClass: AuthGuard, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }
